<template>
  <transition name="fade">
    <base-card v-if="notes">
      <template v-slot:title>
        <h3 class="d-inline-block mr-2">{{ $t('menu.notes') }}</h3>
        <b-badge class="d-inline-block" pill variant="light" v-if="!readonly && notes.patientNotes.lastUpdate">{{ `${$t('appointment-notes.last-update')} ${(lastUpdate)}` }}</b-badge>
      </template>
      <component :is="readonly ? 'div' : 'delayed-input-delegate'" @delayedInput="saveNotes">
        <base-textarea :label="$t('appointment-notes.notes')" v-model="notes.notes" :placeholder="$t('appointment-notes.write-here')"></base-textarea>
        <base-textarea :label="$t('appointment-notes.patientNotes')" v-model="notes.patientNotes.text" :description="$t('appointment-notes.invisible-for-patient')" :placeholder="$t('appointment-notes.write-here')"></base-textarea>
      </component>
    </base-card>
  </transition>
</template>

<script>
import BaseTextarea from '@/components/base/forms/BaseTextarea'
import BaseCard from '@/components/base/ui/BaseCard'
import DelayedInputDelegate from 'vue-delayed-input-delegate'
import filters from '@/plugins/filters'
import { BBadge } from 'bootstrap-vue'

export default {
  name: 'appointment-info',
  components: {
    BaseTextarea,
    DelayedInputDelegate,
    BBadge,
    BaseCard
  },
  props: {
    appointmentId: {
      type: Number,
      required: false,
      default () {
        return this.$store.state.appointment.id
      }
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      notes: null
    }
  },
  created () {
    this.loadNotes()
  },
  methods: {
    loadNotes () {
      this.$api.get(`appointments/notes/${this.appointmentId}`).then((response) => {
        this.notes = response.data.data
      })
    },
    saveNotes () {
      this.$api.post(`appointments/notes`, {
        appointmentId: this.appointmentId,
        notes: this.notes.notes,
        patientNotes: {
          text: this.notes.patientNotes.text
        }
      }).then((response) => {
        let notes = response.data.data
        if (notes) {
          this.notes.patientNotes.lastUpdate = notes.patientNotes.lastUpdate
        }
      })
    }
  },
  computed: {
    lastUpdate () {
      return filters.beautifyDate(this.notes.patientNotes.lastUpdate, 'DD/MM/YYYY HH:mm:ss')
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/shared/AppointmentNotes.vue